export default __webpack_public_path__ + "static/media/buy-icon.9595d15e.svg";